'use client';
import { AppBar, AppLoader } from '~/components';

import { SearchForm } from '~/app/search/_components';
import { useQueryState } from 'nuqs';

import styles from './PageLoader.module.css';
import { usePathname } from 'next/navigation';
export const PageLoader = () => {
  const pathname = usePathname();
  const [q] = useQueryState('q');

  const isSearchPath = pathname.startsWith('/search');
  const isCategorySearchResultPath = pathname.startsWith('/category');

  return (
    <div className={styles.container}>
      <AppBar
        {...(isSearchPath && q && { slot: <SearchForm value={q} readOnly />, actions: ['home'] })}
        {...(isCategorySearchResultPath && { actions: ['search', 'home'] })}
      />
      <AppLoader />
    </div>
  );
};
